<template>
  <div>
    <v-app-bar
      flat
      :color="color"
      :dense="dense"
    >
      <v-toolbar-title v-if="title">
        {{ title }}
      </v-toolbar-title>
      <slot name="left" />

      <v-spacer />

      <slot />
    </v-app-bar>

    <v-divider />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
